export enum StatusIntent {
    AnalisysUnipar = 1,
    PendingCustomer = 2
}